import { render, staticRenderFns } from "./CardsView.vue?vue&type=template&id=55c3afa6&"
import script from "./CardsView.vue?vue&type=script&lang=js&"
export * from "./CardsView.vue?vue&type=script&lang=js&"
import style0 from "./CardsView.vue?vue&type=style&index=0&id=55c3afa6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports